import { render, staticRenderFns } from "./BusinessPlanSignUp.vue?vue&type=template&id=0ef84f72"
import script from "./BusinessPlanSignUp.vue?vue&type=script&lang=js"
export * from "./BusinessPlanSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports